import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-10793b63")

_pushScopeId("data-v-10793b63")
const _hoisted_1 = { class: "fs-3 fw-bold mb-5 text-center" }
const _hoisted_2 = { class: "row align-items-end" }
const _hoisted_3 = { class: "col-md-8" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "row align-items-end" }
const _hoisted_6 = { class: "col-md-8" }
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "fs-6 fw-bold mb-1 text-center" }
const _hoisted_10 = { class: "input-item el-input__inner" }
const _hoisted_11 = { class: "align-items-center fs-6 fw-bold d-block" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "text-wrapper m-0"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-upload",
  style: {"text-align":"right","margin-left":"7px"}
}, null, -1)
const _hoisted_15 = {
  key: 0,
  class: "col-md-12 mt-3"
}
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "col-md-8" }, null, -1)
const _hoisted_18 = { class: "col-md-4" }
const _hoisted_19 = { class: "hover-effect" }
const _hoisted_20 = { class: "image-heading" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { style: {"clear":"both"} }, null, -1)
const _hoisted_23 = { class: "col-md-12 mt-8" }
const _hoisted_24 = { class: "fv-row mb-5 mt-2" }
const _hoisted_25 = { class: "d-flex flex-stack" }
const _hoisted_26 = { class: "me-5" }
const _hoisted_27 = { class: "fs-5 fw-bold" }
const _hoisted_28 = { class: "fs-7 fw-bold text-gray-400" }
const _hoisted_29 = { class: "form-check-label fw-bold text-gray-400" }
const _hoisted_30 = { class: "col-md-12 mt-8" }
const _hoisted_31 = { class: "fv-row mb-5 mt-2" }
const _hoisted_32 = { class: "d-flex flex-stack" }
const _hoisted_33 = { class: "me-5" }
const _hoisted_34 = { class: "fs-5 fw-bold" }
const _hoisted_35 = { class: "fs-7 fw-bold text-gray-400" }
const _hoisted_36 = { class: "form-check-label fw-bold text-gray-400" }
const _hoisted_37 = {
  class: "col-md-12 mt-12",
  style: {"text-align":"end"}
}
const _hoisted_38 = { class: "indicator-label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Select = _resolveComponent("Select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Image = _resolveComponent("Image")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    model: _ctx.basicFormData,
    ref: "basicFormRef"
  }, {
    default: _withId(() => [
      _createVNode(_component_InnerLoader, {
        loading: _ctx.loader,
        innerLoading: true
      }, null, 8, ["loading"]),
      _createVNode("label", _hoisted_1, _toDisplayString(`${_ctx.$t('message.BASIC')} ${_ctx.$t('message.INFO')}`), 1),
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_Input, {
            type: "text",
            name: "name",
            label: `${_ctx.$t('message.NAME')} (${_ctx.locale})`,
            placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.NAME')}`,
            requiredMsg: `${_ctx.$t('message.NAME')} ${_ctx.$t('message.IS_REQUIRED')}`,
            "onUpdate:name": _cache[1] || (_cache[1] = ($event: any) => (_ctx.basicFormData.name = $event)),
            target: "name",
            required: true,
            onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateValue(_ctx.basicFormData.name))),
            value: _ctx.basicFormData.name
          }, null, 8, ["label", "placeholder", "requiredMsg", "name", "value"])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_Select, {
            name: "locale",
            target: "locale",
            callEmit: true,
            required: false,
            label: false,
            locale: _ctx.locale,
            "onUpdate:locale": _cache[3] || (_cache[3] = ($event: any) => (_ctx.locale = $event)),
            selectData: _ctx.locales,
            value: _ctx.locale,
            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeLang(_ctx.locale)))
          }, null, 8, ["locale", "selectData", "value"])
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_Input, {
            type: "text",
            name: "sub_title",
            label: `${_ctx.$t('message.SUB_TITLE')} (${_ctx.locale})`,
            placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.SUB_TITLE')}`,
            sub_title: _ctx.basicFormData.sub_title,
            "onUpdate:sub_title": _cache[5] || (_cache[5] = ($event: any) => (_ctx.basicFormData.sub_title = $event)),
            target: "sub_title",
            required: false,
            onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateSubTitleValue(_ctx.basicFormData.sub_title))),
            value: _ctx.basicFormData.sub_title
          }, null, 8, ["label", "placeholder", "sub_title", "value"])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_Select, {
            name: "locale",
            target: "locale",
            callEmit: true,
            required: false,
            label: false,
            locale: _ctx.locale,
            "onUpdate:locale": _cache[7] || (_cache[7] = ($event: any) => (_ctx.locale = $event)),
            selectData: _ctx.locales,
            value: _ctx.locale,
            onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changeLang(_ctx.locale)))
          }, null, 8, ["locale", "selectData", "value"])
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('message.THUMBNAIL')), 1),
        _createVNode("div", _hoisted_10, [
          _createVNode("label", _hoisted_11, [
            (_ctx.imageLabel == '')
              ? (_openBlock(), _createBlock("span", _hoisted_12, _toDisplayString(`${_ctx.$t('message.CHOOSE')} ${_ctx.$t('message.IMAGE')}`), 1))
              : (_openBlock(), _createBlock("p", _hoisted_13, _toDisplayString(_ctx.imageLabel), 1))
          ]),
          _createVNode(_component_el_button, {
            type: "info",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.triggerFile())),
            plain: "",
            class: "px-2 py-2 mx-1 btn-custom"
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('message.UPLOAD')) + " ", 1),
              _hoisted_14
            ]),
            _: 1
          })
        ]),
        _createVNode("input", {
          type: "file",
          class: "form-control",
          ref: "inputFile",
          style: {"display":"none"},
          accept: "image/png, image/jpg, image/jpeg",
          onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.ImageHandler && _ctx.ImageHandler(...args))),
          id: "customFile"
        }, null, 544)
      ]),
      (_ctx.basicFormData.images.length != 0)
        ? (_openBlock(), _createBlock("div", _hoisted_15, [
            _createVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode("div", _hoisted_18, [
                _createVNode("div", _hoisted_19, [
                  _createVNode("img", {
                    src: _ctx.basicFormData.images[0].src,
                    alt: "uploaded Images",
                    class: "image-thumbnail"
                  }, null, 8, ["src"]),
                  _createVNode("span", _hoisted_20, [
                    _createVNode("i", {
                      class: "fas fa-search",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showMedia(0)))
                    }),
                    _hoisted_21,
                    _createVNode("i", {
                      class: "fas fa-trash-alt",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.removeMedia(0, _ctx.basicFormData.images[0].id)))
                    })
                  ])
                ])
              ]),
              _hoisted_22,
              _createVNode(_component_Image)
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_23, [
        _createVNode("div", _hoisted_24, [
          _createVNode("div", _hoisted_25, [
            _createVNode("div", _hoisted_26, [
              _createVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('message.LIMIT_TO_CUSTOMER')), 1),
              _createVNode("div", _hoisted_28, _toDisplayString(`${_ctx.$t('message.SHIPPING_STATUS_ACTIVE_OR_INACTIVE_CUSTOMER')}`), 1)
            ]),
            _createVNode("span", _hoisted_29, [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.basicFormData.customer_status,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.basicFormData.customer_status = $event))
              }, null, 8, ["modelValue"])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_30, [
        _createVNode("div", _hoisted_31, [
          _createVNode("div", _hoisted_32, [
            _createVNode("div", _hoisted_33, [
              _createVNode("label", _hoisted_34, _toDisplayString(_ctx.$t('message.SHIPPING_STATUS')), 1),
              _createVNode("div", _hoisted_35, _toDisplayString(`${_ctx.$t('message.SHIPPING_STATUS_ACTIVE_OR_INACTIVE')}`), 1)
            ]),
            _createVNode("span", _hoisted_36, [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.basicFormData.status,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.basicFormData.status = $event))
              }, null, 8, ["modelValue"])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_37, [
        _createVNode("button", {
          type: "button",
          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$router.push({ path: '/system/settings/shipping-methods' }))),
          class: "btn btn-white me-3"
        }, _toDisplayString(_ctx.$t('message.CANCEL')), 1),
        _createVNode("button", {
          type: "button",
          class: "btn btn-custom",
          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('submitHandlerForm')))
        }, [
          _createVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('message.SUBMIT')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["model"]))
})